// extracted by mini-css-extract-plugin
export default {"sectionRoot":"CaseStudies_sectionRoot__RQoRH","sectionContentLayout":"CaseStudies_sectionContentLayout__yN+15"};